import { Component, OnInit } from '@angular/core';

/**
 * 已弃用
 * @deprecated
 */
@Component({
  selector: 'app-expression-schema-grid',
  templateUrl: './expression-schema-grid.component.html',
  // styleUrls: ['./expression-schema-grid.component.css']
})
export class ExpressionSchemaGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
